import { commercialUsageTypes, UsageType } from '@shared/types';
import { CommercialType } from '@talon/web/lib/api';
import { Select, SelectProps, Text } from 'grommet';
import { DocumentVideo } from 'grommet-icons';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { TalonTip } from '../TalonTip';

export interface IUsageTypeSelectProps {
  onChange: (val: UsageType) => void;
  commercialType?: CommercialType;
  val?: UsageType;
  id?: string;
  name?: string;
  dropAlign?: SelectProps['dropAlign'];
}

export const UsageTypeSelect = observer(
  ({ commercialType, val, onChange, id = 'usage-type', name = 'usage-type', dropAlign }: IUsageTypeSelectProps) => {
    const defaultOptions = commercialType ? commercialUsageTypes[commercialType] : Object.values(UsageType);

    /** State **/
    const [filteredOptions, setFilteredOptions] = useState<UsageType[]>(defaultOptions);

    /** Methods **/
    const filterTypes = (query: string) => {
      if (query === '') {
        setFilteredOptions(defaultOptions);
        return;
      }
      const exp = new RegExp(query.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
      const filtered = defaultOptions.filter((t) => exp.test(t));
      setFilteredOptions(filtered);
    };

    /** Render **/
    return (
      <Select
        options={filteredOptions}
        value={val}
        size="small"
        icon={
          <TalonTip content={<Text>Choose Activity Type</Text>}>
            <DocumentVideo />
          </TalonTip>
        }
        placeholder="Choose..."
        searchPlaceholder="Search types..."
        onSearch={(query) => filterTypes(query)}
        onChange={({ value }) => onChange(value)}
        onBlur={() => setFilteredOptions(defaultOptions)}
        id={id}
        name={name}
        dropAlign={dropAlign}
      />
    );
  }
);
